export enum DateGap {
  Day = '1 DAYS',
  Week = 'WEEK',
  Month = '1 MONTHS',
  Year = 'YEAR',
}

export enum DateFormats {
  '1 DAYS' = 'P',
  'WEEK' = 'dd MMM yyyy',
  '1 MONTHS' = 'MMMM yyyy',
  MonYear = 'MMM yyyy',
  YEAR = 'yyyy',
}

type EnsureGapHasFormats = (typeof DateFormats)[DateGap];

export const getUTCDate = (dateString: string) => new Date(`${dateString.replace(' ', 'T')}Z`);

export const getNowAsISO = (): string => new Date().toISOString();

export const getPastDateAsISO = (daysAgo: number): string => {
  const DAYS_IN_MS = 24 * 60 * 60 * 1000;
  return new Date(Date.now() - daysAgo * DAYS_IN_MS).toISOString();
};
